import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss']
})
export class LegendComponent implements OnInit {

  @Output() closeClick = new EventEmitter();
  showLegend = false;

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  closeLegend() {
    this.closeClick.emit();
  }

}
